export enum CardColor {
    blue = 'blue',
    danger = 'danger',
    grey = 'grey',
    orange = 'orange',
    primary = 'primary',
    secondary = 'secondary',
    success = 'success',
}
